import AuthService from './service';


const authCheckGuard = function(to, from, next) {
  const authorized = AuthService.isAuthorized();

  if (to.matched.some(record => record.meta.requiresAuth) && !authorized) {
    const params = to.params || from.params;
    return next({ name: 'auth', params: { from: to, ...params} });
  }

  if (to.matched.some(record => record.meta.requiresAnon) && authorized) {
    const params = to.params || from.params;
    return next({ name: 'main', params: params });
  }

  next();
};

export { authCheckGuard };
